/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/return-await */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/consistent-type-assertions */

import { Actions, Mutations } from '../enums/StoreEnums'
import { Module, Action, VuexModule, Mutation } from 'vuex-module-decorators'
// import { _whoAmiRequest } from '@frontcommon/shared/src/modelos/login/_whoAmiRequest'
// import CookieService from '../../servicios/CookieService'
// import HelperSecurity from '../../funciones/HelperSecurity'
// import HelperRfp from '../../funciones/HelperRfp'
import { TYPES } from '../../../domain/types'
import 'reflect-metadata'
import MessageService, { MessageType } from '../../servicios/MessageService'
import { Container } from 'inversify'
import { CustomMenu, CustomMenu as menu } from '../../../domain/modelos/menu/CustomMenu'
import { authResponse } from '../../../../entidades/builderMaster/auth/domain/authResponse'
import { authRequest } from '../../../../entidades/builderMaster/auth/domain/authRequest'
import { IServiceAuth } from '../../../../entidades/builderMaster/auth/application/IServiceAuth'
import { LocalService, CookieService } from '../../servicios'


import { IServiceMenu } from '../../../../entidades/builder/menu/application/IServiceMenu'
import HelperMenu from '../../../../entidades/builder/menu/infrastructure/HelperMenu'
import { IapLocalization } from '../../../../entidades/builder/localization/domain/iapLocalization';
import * as vueRouter from 'vue-router'
import { IapmUser } from '../../../../entidades/builderMaster/user/domain/iapmUser'
import { IapmoEntityProfile } from '../../../../entidades/builderModel/entityProfile/domain/entityProfile'
import { IapmGroup } from '../../../../entidades/builderMaster/user/domain/iampGroup'
import { IapObjectGroup } from '../../../../entidades/builder/objectgroup/domain/iapObjectGroup'
import { IServiceDobleAuthenticationUser } from '../../../../entidades/builderMaster/user/application/IServiceDobleAuthenticationUser'
import {IapApplicationConfiguration } from '../../../../entidades/builder/application/domain/iapApplicationConfiguration';
import { autoAuthRequest } from '../../../../entidades/builderMaster/auth/domain/autoAuthRequest'
import { AppLayoutConfig } from '../../../../entidades/builder/template/infrastructure/prime/AppLayoutConfig'
import { IapCatalog } from '../../../../entidades/builder/catalog/domain/iapCatalog'
import { debug } from 'console'


@Module
export default class AuthModule extends VuexModule implements authResponse {
  access_token = '' as string
  expires_in = '' as string
  refresh_token = '' as string
  user = {} as IapmUser
  dobleFactorCode = '' as string
  dobleFactorFechaCaducidad = '' as string
  dobleFactorCodeFechaCaducidad = '' as string
  currentProfileId = null as number | null
  currentProfileType = '' as string
  isAuthenticated = false
  menusApp = []
  menusLocalizations = {}
  computerName = '' as string
  routes = null as any
  appConfig = [] as IapApplicationConfiguration[];
  appConfigCatalog = [] as IapCatalog[];
  appLayoutConfig = {} as AppLayoutConfig;

  get getAppConfig(): IapApplicationConfiguration[] {
    return this.appConfig;
  }

  get getAppConfigCatalog(): IapCatalog[] {
    return this.appConfigCatalog;
  }

  get getAppLayoutConfig(): AppLayoutConfig {
    return this.appLayoutConfig;
  }

  get isUserAuthenticated(): boolean {
    return this.access_token !== undefined && this.access_token !== '' // && this.expires_in > now
  }

  get getRoutes(): vueRouter.Router {
    return this.routes
  }

  get getAcessToken(): string {
    return this.access_token
  }

  get getDobleFactorCode(): string {
    return this.dobleFactorCode
  }

  get getDobleFactorCodeFechaCaducidad(): string {
    return this.dobleFactorCodeFechaCaducidad
  }

  get getDobleFactorFechaCaducidad(): string {
    return this.dobleFactorFechaCaducidad
  }

  get getApplicationMenus(): CustomMenu[] {
    return this.menusApp
  }

  get getMenusLocalizations(): Object {
    return this.menusLocalizations
  }

  get getRefreshToken(): string {
    return this.refresh_token
  }

  get getCurrentUser(): IapmUser {
    return this.user
  }

  get getCurrentProfile(): number | null {
    return this.currentProfileId
  }

  get getCurrentProfileType(): string {
    return this.currentProfileType;
  }

  get getGroups(): IapmGroup[]  {
    return this.user?.groups;
  }

  get getObjectGroups(): IapObjectGroup[] {
    return this.user?.objectGroups;
  }

  get currentBrokerId(): number | null {
    return this.user?.entityMainId
  }

  get currentBrokerLogo(): string | null {
    const img = this.user?.profilePhotoFilename ?? ''
    if (img) {
      return 'data:image/png;base64, ' + img
    }
    else {
      return null
    }

  }

  get getComputerName(): string {
    return this.computerName
  }


  @Action({ rawError: true })
  async [Actions.AUTH](params: any) {
    const request: authRequest = params[0].value
    const container: Container = params[1]
    await new Promise<void>((resolve, reject) => {
      const _srvAuth = container.get<IServiceAuth>(TYPES.AUTH_SERVICE)
      _srvAuth.auth(request)
        .then(async (response: any) => {
          if (response.data.failed === true) {
            //MessageService.showMessage(MessageType.Error, 'Error de validación', response.data.message)
            reject()
          } else {
            this.context.commit(Mutations.PURGE_AUTH);
            this.context.commit(Mutations.SET_AUTH, response.data.data)
            if (request.brokerId != null && request.external == false) {
              this.context.commit(Mutations.SETPROFILE, request.profileId)
            }
            else if (request.brokerId != null && request.external == true) {
              this.context.commit(Mutations.SETPROFILE, response.data.data.profileId)
            }
            //resolve()

            await new Promise<void>((resolve2, reject) => {
              _srvAuth.whoAmI()
                .then((response: any) => {
                  var user = response
                  this.context.commit(Mutations.WHOAMI, [this, user])
                  resolve2()
                  resolve()
                })
                .catch((e) => {
                  reject()
                })
            })

          }
        })
        .catch((e) => {
          reject()
        })
    })
  }


  @Action({ rawError: true })
  async [Actions.AUTOAUTH](params: any) {
    const request: autoAuthRequest = params[0].value
    const container: Container = params[1]
    await new Promise<void>((resolve, reject) => {
      const _srvAuth = container.get<IServiceAuth>(TYPES.AUTH_SERVICE)
      _srvAuth.autoAuth(request)
        .then(async (response: any) => {
          if (response.data.failed === true) {
            //MessageService.showMessage(MessageType.Error, 'Error de validación', response.data.message)
            reject()
          } else {
            this.context.commit(Mutations.SET_AUTH, response.data.data)
            // Siempre es externo el autoauth
            //if (request.brokerId != null && request.external == false) { // pq el whoami pone siempre el perfil principal de la correduría, al cambiar a otro perfil pondremos el que se selecciona
            //  this.context.commit(Mutations.SETPROFILE, request.profileId)
            //}
            //if (request.brokerId != null && request.external == true) {
              this.context.commit(Mutations.SETPROFILE, response.data.data.profileId)
            //}
            //resolve()

            await new Promise<void>((resolve2, reject) => {
              _srvAuth.whoAmI()
                .then((response: any) => {
                  var user = response
                  this.context.commit(Mutations.WHOAMI, [this, user])
                  resolve2()
                  resolve()
                })
                .catch((e) => {
                  reject()
                })
            })

          }
        })
        .catch((e) => {
          reject()
        })
    })
  }


  @Action({ rawError: true })
  async [Actions.REGISTER](params: any) {
    const request: IapmUser = params[0]
    const container: Container = params[1]
  /*
    await new Promise<void>((resolve, reject) => {
      const _srvUser = container.get<IServiceUser>(TYPES.USER_SERVICE)
      _srvUser.get(request)
        .then((response: any) => {
           if (response.data.failed === true) {
             MessageService.showMessage(MessageType.Error, 'Error de validación', response.data.message)
           } else {
             this.context.commit(Mutations.SET_AUTH, response.data.data)
           }
          
          resolve()
        })
        .catch((e) => {
          
          reject()
        })
      
    })
    */
  }

  @Action({ rawError: true })
  async [Actions.GET_DOBLE_FACTOR_USER_TYPES](params: any) {
    const userId: number = params[0]
    const container: Container = params[1]

    await new Promise<void>((resolve, reject) => {
      const _srvUserDobleFactor = container.get<IServiceDobleAuthenticationUser>(TYPES.DOBLE_FACTOR_USER_SERVICE)
      _srvUserDobleFactor.getDobleFactorUserCode(userId)
        .then((response: any) => {
          /* if (response.data.failed === true) {
             MessageService.showMessage(MessageType.Error, 'Error de validación', response.data.message)
           } else {
             this.context.commit(Mutations.SET_AUTH, response.data.data)
           }*/

          resolve()
        })
        .catch((e) => {
          reject()
        })
    })
  }

  @Action({ rawError: true })
  async [Actions.SET_DOBLE_FACTOR_USER_CODE](params: any) {
    const userId: number = params[0]
    const dobleFactorType: string = params[1]
    const container: Container = params[2]

    await new Promise<void>((resolve, reject) => {
      const _srvUserDobleFactor = container.get<IServiceDobleAuthenticationUser>(TYPES.DOBLE_FACTOR_USER_SERVICE)
      _srvUserDobleFactor.setDobleFactorUserCode(userId, dobleFactorType)
        .then((response: any) => {
          /* if (response.data.failed === true) {
             MessageService.showMessage(MessageType.Error, 'Error de validación', response.data.message)
           } else {
             this.context.commit(Mutations.SET_AUTH, response.data.data)
           }*/
           this.context.commit(Mutations.SET_DF_CODE, response)
          resolve()
        })
        .catch((e) => {
          reject()
        })
    })
  }

  @Action({ rawError: true })
  async [Actions.CONFIRM_DOBLE_FACTOR_USER](params: any) {
    const userId: number = params[0]
    const container: Container = params[1]

    await new Promise<void>((resolve, reject) => {
      const _srvUserDobleFactor = container.get<IServiceDobleAuthenticationUser>(TYPES.DOBLE_FACTOR_USER_SERVICE)
      _srvUserDobleFactor.confirmDobleFactorUser(userId)
        .then((response: any) => {
          /* if (response.data.failed === true) {
             MessageService.showMessage(MessageType.Error, 'Error de validación', response.data.message)
           } else {
             this.context.commit(Mutations.SET_AUTH, response.data.data)
           }*/
           this.context.commit(Mutations.SET_DF_CODE, response)
          resolve()
        })
        .catch((e) => {
          reject()
        })
    })
  }

  @Action({ rawError: true })
  async [Actions.CHANGEPROFILE](profileId: number) {
    this.context.commit(Mutations.SETPROFILE, profileId)
  }

  @Mutation
  async [Mutations.WHOAMI](params: any) {
    const _this = params[0]
    const user: IapmUser = params[1]
    _this.context.commit(Mutations.SET_USER, user)
  }

  @Mutation
  async [Mutations.SETPROFILE](profileId: number) {
    this.currentProfileId = +profileId
  }

  @Mutation
  [Mutations.SET_USER](data: any) {
    this.user = data.data.user;
    this.currentProfileType = data.data.perfil?.profileId;
    this.user.userEntityGroups = data.data.userEntityGroups;
    this.user.catalogs = data.data.catalogs;
    this.user.groups = data.data.groups;
    this.user.objectGroups = data.data.objectGroups;
    this.currentProfileId = data.data.perfil?.id ?? 0;
    this.appConfig = data.data.applicationConfigurations;
    this.appConfigCatalog = data.data.applicationCatalogs;
  }

  @Mutation
  [Mutations.SET_DF_CODE](response: any) {
    this.dobleFactorCode = response.codigo,
    this.dobleFactorCodeFechaCaducidad = response.fechaCaducidadCodigo,
    this.dobleFactorFechaCaducidad = response.fechaCaducidadDobleAuth
  }

  @Mutation
  [Mutations.SET_AUTH](data: any) {    
    this.access_token = data.access_token.toString()
    this.expires_in = data.expires_in.toString()
    this.refresh_token = data.refresh_token.toString()
    this.user.entityMainId = data.brokerId
    this.isAuthenticated = true
  }

  @Mutation
  [Mutations.SET_MENU](params: any) {
    const menus: never[] = params[0]
    const localizations: any = params[1]
    this.menusApp = menus
    this.menusLocalizations = localizations
  }

  @Mutation
  [Mutations.SET_ROUTES](routes: vueRouter.Router) {
    this.routes = routes.getRoutes()
  }

  @Mutation
  async [Mutations.SET_APPCONFIG](cfgData: IapApplicationConfiguration[]) {
    this.appConfig = cfgData    
  }

  @Mutation
  async [Mutations.SET_APPCONFIGCATALOG](cfgData: IapCatalog[]) {
    this.appConfigCatalog = cfgData    
  }

  @Mutation
  async [Mutations.SET_APPLAYOUTCONFIG](cfgData: any) {
    this.appLayoutConfig = cfgData    
  }

  @Action({ rawError: true })
  async [Actions.SET_ROUTES](routes: any) {
    this.context.commit(Mutations.SET_ROUTES, routes)
  }

  @Action({ rawError: true })
  async [Actions.SET_MENU](params: any) {
    const applicationId: number = params[0]
    const applicationVersion: number = params[1]
    const container: Container = params[2]

    await new Promise<CustomMenu[] | void>((resolve, reject) => {
      if (container){
        const _srvMenu = container.get<IServiceMenu>(TYPES.MENU_SERVICE)
        _srvMenu.getByApplicationId(this.user?.isAdmin ? 1 : 0, this.currentProfileId ?? 0, applicationId, applicationVersion)
          .then((response) => {
            HelperMenu.addMenuBuilder(this.user,applicationId, applicationVersion,response);
            const menus  = HelperMenu.buildMenu(response);
            const localizations = response.filter(x => x.localizations && x.localizations.length > 0).map(x => x.localizations)

            let messages = buildLocalizations(localizations.flat() as any);

            this.context.commit(Mutations.SET_MENU, [menus, messages])
            resolve()
          })
          .catch((e) => {
            
            reject()
          })
      }
      else{
        resolve([])
      }

    })

    function buildLocalizations(localizations: IapLocalization[]) {
      let response = {
        locale: 'es',
        messages: {}
      };
    
      let distinctCultures = localizations.map(item => item.idCulture.split('-').pop()).filter((value, index, self) => self.indexOf(value) === index);
      let distinctMenus = localizations.map(item => item.objetoId).filter((value, index, self) => self.indexOf(value) === index);
    
      distinctCultures.forEach(c => {
        const objectCulture = {};
        const myCultureName = c;
    
        localizations.filter(l => l.idCulture.split('-').pop() == c).forEach(l => {
          const objectMenu = {};
          const myMenuName = l.objetoId;
          distinctMenus.forEach(m => {
            Object.assign(objectMenu, { label: l.title });
            Object.assign(objectMenu, { description: l.description });
          });
          Object.assign(objectCulture, { [myMenuName]: objectMenu });
          
        });
        Object.assign(response.messages, { [myCultureName as any]: objectCulture });
      });
            return response;
    }
  }

  

  @Mutation
  [Mutations.PURGE_AUTH]() {    
    this.access_token = ''
    this.expires_in = ''
    this.refresh_token = ''
    this.dobleFactorCode = ''
    this.dobleFactorFechaCaducidad = ''
    this.dobleFactorCodeFechaCaducidad = ''
    this.isAuthenticated = false;
    this.currentProfileId = null;
    this.currentProfileId = null;
    this.user = {} as IapmUser;
    this.menusApp = [];
    this.routes = null;
    this.appConfig = [];
    this.appConfigCatalog = [];
    this.appLayoutConfig = {} as AppLayoutConfig;
    this.menusLocalizations = {};
    LocalService.destroyAll();
    CookieService.destroyAll();
  }



  @Mutation
  [Mutations.SET_CLIENTCOMPUTERNAME]() {
    /*if (!this.computerName)
    {
      
      //const computerName = require('computer-name')
      //this.computerName = computerName()
    }
    */
  }


  @Action({rawError: true})
  [Actions.LOGOUT]() {
    return new Promise<void>((resolve) => {
      this.context.commit(Mutations.PURGE_AUTH);
      resolve();
    });
  }


  get menuUser(): any {
    // const user = this._user
    const menus = this.menusApp

    // return function () {
    // return HelperSecurity.buildUserMenu(user, menus)
    // }
    const data: menu[] = []

    menus.forEach(function (value: any) {
      // const itemsFiltered = value.items.filter((x) => {
      // return checkAccess(x.builtin, x.contrato, x.directivas, user)
      // })

      // if (itemsFiltered.length > 0) {
      // value.items = itemsFiltered
      data.push(value)
      // }
    })

    return data
  }
}
